import { render, staticRenderFns } from "./buscaExame.vue?vue&type=template&id=faa3ac20&scoped=true"
import script from "./buscaExame.vue?vue&type=script&lang=js"
export * from "./buscaExame.vue?vue&type=script&lang=js"
import style0 from "./buscaExame.vue?vue&type=style&index=0&id=faa3ac20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa3ac20",
  null
  
)

export default component.exports